/**
 * Fuzzy Search Engine for Neural Mesh Navigator
 * Powered by Fuse.js
 */

import Fuse from 'fuse.js'

export class NeuralSearchEngine {
  constructor(nodes) {
    this.nodes = nodes
    this.fuseOptions = {
      keys: [
        { name: 'label', weight: 0.4 },
        { name: 'description', weight: 0.3 },
        { name: 'category', weight: 0.15 },
        { name: 'id', weight: 0.15 }
      ],
      threshold: 0.4,
      distance: 100,
      includeScore: true,
      includeMatches: true,
      minMatchCharLength: 1
    }
    
    this.fuse = new Fuse(nodes, this.fuseOptions)
    this.searchHistory = []
    this.maxHistory = 10
  }

  search(query) {
    if (!query || query.trim() === '') {
      return this.getRecentSearches()
    }

    const results = this.fuse.search(query)
    
    return results.map(result => ({
      ...result.item,
      score: 1 - (result.score || 0),
      matches: result.matches
    }))
  }

  addToHistory(nodeId) {
    const existingIndex = this.searchHistory.indexOf(nodeId)
    if (existingIndex > -1) {
      this.searchHistory.splice(existingIndex, 1)
    }
    
    this.searchHistory.unshift(nodeId)
    
    if (this.searchHistory.length > this.maxHistory) {
      this.searchHistory.pop()
    }

    this.saveHistory()
  }

  getRecentSearches() {
    return this.searchHistory
      .map(id => this.nodes.find(n => n.id === id))
      .filter(Boolean)
      .slice(0, 5)
  }

  saveHistory() {
    try {
      localStorage.setItem('neural-mesh-search-history', 
        JSON.stringify(this.searchHistory))
    } catch (e) {
      console.warn('Could not save search history:', e)
    }
  }

  loadHistory() {
    try {
      const saved = localStorage.getItem('neural-mesh-search-history')
      if (saved) {
        this.searchHistory = JSON.parse(saved)
      }
    } catch (e) {
      console.warn('Could not load search history:', e)
    }
  }

  getSuggestions(query) {
    if (!query) return []
    
    const results = this.search(query)
    return results.slice(0, 6).map(r => ({
      id: r.id,
      label: r.label,
      icon: r.icon,
      category: r.category,
      relevance: r.score
    }))
  }

  updateNodes(nodes) {
    this.nodes = nodes
    this.fuse = new Fuse(nodes, this.fuseOptions)
  }
}
